import Id from './base'

/**
 * A "Tracking ID" is minted for every guest user who visits the site. If that user registers,
 *   the tracking ID is persisted and used for all future visits to the site by that user (once
 *   they login). This association is made using the `identify` method.
 */
export default class TrackingId extends Id {
  public constructor() {
    super('trackingId')
  }
}
